<template>
  <AuthLayout>
    <template #title>Créer un compte</template>
    <template #subTitle>Rejoignez l'aventure king recharge</template>
    <template #redirectQuestion>Déjà membre ?</template>
    <template #redirectLink>
      <router-link to="/login" class="font-bold text-secondary-400 hover:text-secondary-300 transition-colors underline decoration-white/30 underline-offset-4">Se connecter</router-link>
    </template>

    <div class="bg-white/95 backdrop-blur-md rounded-[2rem] shadow-2xl shadow-gray-200/60 p-8 border border-white/70">
      <form
        class="space-y-4"
        v-bus:EVENTS.USER.REGISTER.submit.prevent
        v-redirect-on="{
          event: $constants.EVENTS.USER.REGISTER_SUCCESS,
          to: '/matches'
        }"
      >
        <!-- Nom et Prénom -->
        <div class="grid grid-cols-2 gap-3">
          <div class="space-y-2">
            <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">nom</label>
            <div class="relative group">
              <input
                name="lastName"
                type="text"
                required
                class="w-full px-4 py-3.5 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
                placeholder="votre nom"
              />
            </div>
          </div>
          <div class="space-y-2">
            <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">prénom</label>
            <div class="relative group">
              <input
                name="firstName"
                type="text"
                required
                class="w-full px-4 py-3.5 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
                placeholder="votre prénom"
              />
            </div>
          </div>
        </div>

        <!-- Téléphone -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">téléphone</label>
          <div class="flex gap-2.5">
            <Listbox
              v-model="selectedCountry"
              as="div"
              class="relative max-w-[120px]"
            >
              <ListboxButton
                ref="countryButton"
                class="px-3 py-3.5 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm font-semibold w-full flex items-center justify-between gap-2 h-full"
              >
                <img
                  v-if="selectedCountry"
                  :src="selectedCountry.flag"
                  class="w-5 h-4 object-cover rounded-sm"
                />
                <span class="flex-1 text-left whitespace-nowrap">{{
                  selectedCountry?.code ? `+${selectedCountry.code}` : '+--'
                }}</span>
                <span class="text-gray-400 text-xs">▼</span>
              </ListboxButton>
              <ListboxOptions
                class="absolute z-50 mt-1 max-h-60 w-max min-w-full overflow-auto rounded-2xl bg-white py-1 shadow-lg shadow-gray-200/50 ring-1 ring-black/5 focus:outline-none text-sm"
              >
                <ListboxOption
                  v-for="country in countries"
                  :key="country.code"
                  :value="country"
                  class="relative cursor-pointer select-none py-3 pl-3 pr-9 hover:bg-gray-50 flex items-center gap-3 whitespace-nowrap transition-colors"
                >
                  <img
                    :src="country.flag"
                    class="w-6 h-4.5 object-cover rounded shadow-sm"
                  />
                  <span class="font-bold text-gray-700">+{{ country.code }}</span>
                  <span class="text-gray-500 font-medium">{{ country.name }}</span>
                </ListboxOption>
              </ListboxOptions>
            </Listbox>
            <input
              name="phoneNumber"
              type="tel"
              required
              class="flex-1 px-4 py-3.5 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
              :placeholder="selectedCountry ? 'Ex: ' + selectedCountry.example : 'Choisir le pays'"
              @click="!selectedCountry && $refs.countryButton?.$el.click()"
              :readonly="!selectedCountry"
            />
            <input
              name="phonePrefix"
              type="hidden"
              :value="selectedCountry?.code || ''"
            />
          </div>
        </div>

        <!-- Email -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">email</label>
          <div class="relative group">
            <input
              name="email"
              type="email"
              required
              class="w-full px-4 py-3.5 pl-12 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
              placeholder="votre@email.com"
            />
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-secondary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
        </div>

        <!-- Mot de passe -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">mot de passe</label>
          <div class="relative group">
            <input
              name="password"
              type="password"
              required
              class="w-full px-4 py-3.5 pl-12 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
              placeholder="créez un mot de passe"
            />
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-secondary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>

        <!-- Champs optionnels -->
        <div class="pt-5 mt-5 border-t border-dashed border-gray-200/70">
          <div class="flex items-center gap-2 mb-4">
            <div class="flex-1 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
            <span class="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">optionnel</span>
            <div class="flex-1 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
          </div>

          <div class="space-y-3">
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-gray-500 ml-1">code d'affiliation</label>
              <input
                name="affiliationCode"
                type="text"
                class="w-full px-4 py-3 rounded-xl border border-gray-200/60 focus:border-secondary-300 focus:ring-2 focus:ring-secondary-50 transition-all bg-white text-sm placeholder:text-gray-400"
                placeholder="code parrain"
              />
            </div>

            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-gray-500 ml-1">whatsapp</label>
              <input
                name="whatsappNumber"
                type="tel"
                class="w-full px-4 py-3 rounded-xl border border-gray-200/60 focus:border-secondary-300 focus:ring-2 focus:ring-secondary-50 transition-all bg-white text-sm placeholder:text-gray-400"
                placeholder="votre numéro"
              />
            </div>
          </div>
        </div>

        <!-- Cases à cocher custom -->
        <div class="space-y-3 pt-3">
          <label class="flex items-start gap-3 cursor-pointer group">
            <div class="relative">
              <input
                name="acceptMoreThan18"
                type="checkbox"
                required
                class="peer sr-only"
              />
              <div class="w-6 h-6 rounded-xl border-2 border-gray-200 peer-checked:bg-gradient-to-br peer-checked:from-secondary-400 peer-checked:to-secondary-500 peer-checked:border-secondary-500 transition-all duration-200 flex items-center justify-center shadow-sm">
                <svg class="w-3.5 h-3.5 text-white opacity-0 peer-checked:opacity-100 transition-opacity" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <span class="text-sm text-gray-600 leading-snug">
              je certifie avoir plus de 18 ans
            </span>
          </label>

          <label class="flex items-start gap-3 cursor-pointer group">
            <div class="relative">
              <input
                name="termOfUse"
                type="checkbox"
                required
                class="peer sr-only"
              />
              <div class="w-6 h-6 rounded-xl border-2 border-gray-200 peer-checked:bg-gradient-to-br peer-checked:from-secondary-400 peer-checked:to-secondary-500 peer-checked:border-secondary-500 transition-all duration-200 flex items-center justify-center shadow-sm">
                <svg class="w-3.5 h-3.5 text-white opacity-0 peer-checked:opacity-100 transition-opacity" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <span class="text-sm text-gray-600 leading-snug">
              j'accepte les
              <a
                href="https://web.kingrecharges.com/cgu"
                target="_blank"
                rel="noopener"
                class="text-secondary-500 font-bold hover:text-secondary-600 underline underline-offset-2 transition-colors"
              >
                conditions d'utilisation
              </a>
            </span>
          </label>
        </div>

        <!-- Bouton -->
        <button
          type="submit"
          class="w-full py-4 px-6 bg-gradient-to-r from-secondary-500 via-secondary-600 to-secondary-500 hover:from-secondary-600 hover:via-secondary-700 hover:to-secondary-600 text-white font-bold rounded-2xl shadow-lg shadow-secondary-500/25 hover:shadow-xl hover:shadow-secondary-500/35 transition-all duration-300 transform hover:scale-[1.01] active:scale-[0.99] relative overflow-hidden"
          :disabled="$stores?.user?.state?.loading"
          :loading="$stores?.user?.state?.loading"
        >
          <span class="relative z-10">Créer mon compte</span>
        </button>
      </form>
    </div>
  </AuthLayout>
</template>

<script setup>
import { ref } from 'vue';
import { COUNTRIES as countries } from '@features/shared/countries';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue';

const selectedCountry = ref(null);
</script>
